module.exports = __webpack_public_path__ + "img/right10.f8a43ccb.png";